module.exports = __webpack_public_path__ + "images/illustrations/reach-person-f20c4e1130635b659bfc38108de9ef95.svg";